// samplingSiteEvents/slice.js

import { samplingEventsListInitialState } from "./samplingEventListsState";
import { makeSamplingEventsListActions } from "./samplingEventsListsActions";

export const createSamplingEventsListSlice = (set, get) => ({
  samplingEventsList: samplingEventsListInitialState,
  samplingEventsListActions: Object.freeze(
    makeSamplingEventsListActions(set, get)
  ),
});
